'use strict';

import { logger } from '@/logging';
import feathers from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
import authentication from '@feathersjs/authentication-client';
import feathersVuex from 'feathers-vuex';
import io from 'socket.io-client';



const serviceURL = process.env.VUE_APP_ROOT_API;
logger.get('feathers').info('Connecting to server at', serviceURL);
const socket = io(serviceURL);

const feathersClient = feathers()
	.configure(socketio(socket))
	.configure(authentication({ storage: window.localStorage }));

const { service, auth, FeathersVuex } = feathersVuex(feathersClient, { idField: 'id', preferUpdate: false });


export { service, auth, FeathersVuex };
